import React from 'react'
import { useNavigationData } from '@/src/context/NavigationContext'

//
import { ButtonGroup, Cta, ButtonNew } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { THEME } from '@/src/utils/common'
import { BUTTON_VARIANT } from '@/src/storybook/ButtonNew/ButtonNew'

const BlockCta = ({ data: { title, text, action, secondaryAction, theme } }) => {
  const location = React.useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location

  return (
    <Cta title={title || ''} text={text || ''} theme={theme || 'green'}>
      <ButtonGroup center>
        {action ? (
          <ButtonNew
            trackingId={action?.trackingId}
            url={getUrl({
              navItem: action,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
            variant={theme === THEME.dark ? BUTTON_VARIANT.GREEN : BUTTON_VARIANT.PRIMARY}
            classes={'new-c-button--cta'}
          >
            {action?.title || ''}
          </ButtonNew>
        ) : null}
        {secondaryAction ? (
          <ButtonNew
            trackingId={secondaryAction?.trackingId}
            variant={'secondary'}
            url={getUrl({
              navItem: secondaryAction,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
            classes={'new-c-button--cta'}
          >
            {secondaryAction?.title || ''}
          </ButtonNew>
        ) : null}
      </ButtonGroup>
    </Cta>
  )
}

export default BlockCta
